/** Совпадает с paygatex-back `authorization-service.ts`. */

export interface AccessSubject {
  role?: string;
  isAdmin?: boolean;
  permissions?: string[];
}
const SELF_PERMISSIONS = [
  'profile.read',
  'profile.manage',
  'security.read',
  'security.manage',
  'project.read',
  'project.manage',
  'invoice.read',
  'invoice.create',
  'invoice.recalculate',
  'balance.read',
  'accounting.read',
  'withdrawal.read',
  'withdrawal.create',
  'withdrawal.cancel',
  'auto_withdrawal.manage',
  'api_key.manage',
] as const;

const ADMIN_PERMISSIONS = [
  'withdrawal.stop.manage',
  'withdrawal.policy.manage',
  'withdrawal.limits.manage',
  'withdrawal.limits.approve',
  'withdrawal.force_cooling',
  'merchant.read',
  'merchant.manage',
  'api_key.revoke',
  'project.read_any',
  'project.manage_any',
  'invoice.read_any',
  'invoice.manage_any',
  'withdrawal.read_any',
  'withdrawal.create_for_merchant',
  'withdrawal.execute',
  'withdrawal.reject',
  'withdrawal.emergency',
  'wallet.read',
  'wallet.manage',
  'address.read',
  'aml.read',
  'aml.manage',
  'aml.policy.manage',
  'aml.billing.manage',
  'compliance.review',
  'compliance.reviewers.manage',
  'refund.read',
  'refund.manage',
  'refund.execute',
  'accounting.read_any',
  'accounting.manage',
  'audit.read',
  'audit.export',
  'platform.manage',
  'reconciliation.read',
  'reconciliation.investigate',
  'reconciliation.resolve',
  'suspense.assign',
  'network_cost_policy.manage',
] as const;

export type Permission = (typeof SELF_PERMISSIONS)[number] | (typeof ADMIN_PERMISSIONS)[number];

const ALL_PERMISSIONS: Permission[] = [...SELF_PERMISSIONS, ...ADMIN_PERMISSIONS];

export const ROUTE_PERMISSION = {
  wallets: 'wallet.read',
  serviceAccounting: 'accounting.read_any',
  auditLog: 'audit.read',
  reconciliation: 'reconciliation.read',
} as const satisfies Record<string, Permission>;

const isAdminUser = (user: AccessSubject): boolean => user.role === 'ADMIN' || user.isAdmin === true;

/** Пустой массив с сервера — это отсутствие прав, а не повод подставить роль. */
export const resolvePermissions = (user: AccessSubject | null | undefined): Permission[] => {
  if (!user) return [];
  if (user.permissions) return user.permissions.filter((item): item is Permission => ALL_PERMISSIONS.includes(item as Permission));
  if (isAdminUser(user)) return ALL_PERMISSIONS;
  return [...SELF_PERMISSIONS];
};

export const hasPermission = (user: AccessSubject | null | undefined, permission: Permission): boolean =>
  resolvePermissions(user).includes(permission);
